
import _ from 'lodash';
import $ from 'jquery';
import { Collection } from 'backbone';

const getIsFetch = (newStamp, oldStamp) => 
	newStamp - oldStamp  >= 60000 && oldStamp !== 0 || oldStamp === 0;


let
	/**
	 * @type {object}
	 */
	checksums = {},
	/**
	 * @type {object}
	 */
	cache = {},
	/**
	 * @type {number}
	 */
	lastStamp = 0;

const
	/**
	 * Get file name from url string
	 * @private
	 * @param {string} url - string url
	 * @return {string} filename
	 */
	getFileName = url => url.split('/').pop().split('.').shift(),
	/**
	 * Get cached data by requested url
	 * @private
	 * @param {string} name - name of json file without extension
	 * @return {object} cached data
	 */
	getCachedData = name => _.get(cache, name, {}),
	/**
	 * Get array of different keys, equal keys wil be transpiled to false
	 * @param {object} checksum
	 * @return {array} array which contain differences
	 */
	getDiffKeys = checksum => (val, key) => checksum[key] !== val && key;

/**
 * @description This class should be used as parent for any collection which is required to cache
 * and listed in checksums.json file. The working mechanism is following:
 * 1) When we're call for JSON file, this class calling for checksums.json first.
 * 2) Check for difference between newly requested file, and object whic is stored in memory.
 * 3) If there is difference, it will call for requested JSON by URL that configured in collection,
 * and store this data in memory. In other case it will return data from memory.
 */
class CacheableJson extends Collection {

	
	get lastStamp() {
		return lastStamp;
	}
	/**
	 * Getter for the checksum object
	 * @protected
	 * @returns {object}
	 */
	get checksums() {
		return checksums;
	}

	/**
	 * Setter for the checksum object
	 * @param {object} params -  Accept only object, in other case will do nothing
	 * @protected
	 */
	set checksums(params) {
		if (_.isObject(params)) {
			checksums = params;
		}

		return checksums;
	}

	/**
	 * Setter for the lastStamp
	 * @param {number} value -  Accept only number, in other case will do nothing
	 * @protected
	 */
	set lastStamp(value) {
		if (_.isNumber(value)) {
			lastStamp = value;
		}
	}

	shouldFetch(options) {
		const newStamp = Date.now();
		const isFetch =  getIsFetch(newStamp, this.lastStamp);
		if(isFetch){
			this.lastStamp = newStamp;
		}
		return isFetch || Boolean(options.isFetch);
	}
	

	/**
	 * This method requesting for JSON file by url which is configured in collection.
	 * Trigger "reset" or "set" event when returning data from cache
	 * @param {object} opts - the same param as default Backbone fetch accept;
	 * @protected
	 * @async
	 * @returns {Promise.<object>}
	 */
	async fetch(opts = {}) {
		

		const options = _.extend({ parse: true }, opts);
		const method = options.reset ? 'reset' : 'set';
		const filename = getFileName(this.url);

		const isFetch = this.shouldFetch(options);
		const checksums = isFetch ? 
			await $.get(`${process.env.JSON_CHECKSUMS_URL}?_=${Date.now()}`) : [];
		const has_checksums = Boolean(this.checksums[filename]);
		const diff = _.map((this.checksums), getDiffKeys(checksums)).includes(filename);
		const is_default_fetch = !has_checksums || diff;
		
		
		this.checksums = isFetch ? checksums : this.checksums;


		if (is_default_fetch) {
			cache[filename] = super.fetch.call(this, options);
		}

		return Promise.resolve(getCachedData(filename)).then(response => {
			if (!is_default_fetch) {
				this[method](response, options);
			}
			

			this.trigger('sync', this, response, options);

			return response;
		});
	}
}

export default CacheableJson;